import { LookupModel } from '../../../../../api/models';

export const AVAILABLE_NOTE_TEMPLATES: LookupModel[] = [
  {
    id: 'default',
    text: 'Default',
    metadata:
      'Call from {{from_number}} {{from_name}} to {{to_number}} {{to_name}} on {{call_start}} lasted {{call_duration}} <a href="{{call_url}}" target="_blank">More Details</a>',
  },

  {
    id: 'defaultAiSummary',
    text: 'Default + AI Call Summary',
    metadata:
      'Call from {{from_number}} {{from_name}} to {{to_number}} {{to_name}} on {{call_start}} lasted {{call_duration}} <a href="{{call_url}}" target="_blank">More Details</a>.<br><br><b>Call Summary:</b> {{call_summary}}',
  },
];
